import { InvoiceCheckoutItemModel } from "../../models/invoice/invoice-checkout-item-model";
import { InvoiceCheckoutModel } from "../../models/invoice/invoice-checkout-model";

export const newmapInvoiceData = (source: any, payId: number): InvoiceCheckoutModel => {
  
  const grossAmount: number = source.length>0
  ?source.taxableAmount + source.taxAmount - source.discountAmount
  :source.taxableAmount + source.taxAmount - source.discountAmount 
   + source.paymentGatewayCharges + source.courierCharges + source.handlingCharges + source.packingCharges;

  const mappedInvoiceItems =
  source.orderDetails
    .filter((item: any) => item.pendingQuantity > 0)
    .map((item: any) => {
      
      const taxableAmount = item.unitPrice * item.pendingQuantity;
      const taxAmount = (taxableAmount * item.gst) / 100;
      const discountAmount = item.discountAmount ?? 0;
      const grossAmount = Math.round(taxableAmount + taxAmount - discountAmount);

      return {
        orderDetailID: item.orderDetailID,
        invoicedQuantity: item.pendingQuantity,
        unitPrice: item.unitPrice,
        taxableAmount,
        taxAmount,
        discountAmount,
        grossAmount,
        batches: item.batches
          ?.filter((b: any) => b.batchId && b.quantity > 0)
          .map((b: any) => ({
            batchId: b.batchId,
            quantity: b.quantity
          }))
      };
    });

  return {
    orderID: source.orderID,
    posID: source.posID,
    taxableAmount: source.taxableAmount,
    taxAmount: source.taxAmount,
    discountAmount: source.discountAmount,
    paymentGatewayCharges: source.paymentGatewayCharges,
    grossAmount: Math.round(grossAmount),
    paymentModeID: payId,
    orderInvoiceDetail: mappedInvoiceItems,
    rewardPointsUsed: source.rewardPointsUsed,
    finalPayableAmount: source.finalPayableAmount,
    redeemMorePoints: source.redeemMorePoints
  };
}
